import React from 'react';

const Accesories = () => {

    return (
        <div>
            <h1 className="text-center">Accesories</h1>
        </div>
    )
}

export default Accesories;